import React from "react";
import { Link } from "react-router-dom";
import "./TermsAndConditions.css";

function TermsAndConditions() {
  return (
    <div className="terms-container">
      <h1 className="text-center">Terms &amp; Conditions — Edgar Lopez Law</h1>
      <p className="text-center">
        <em>Effective Date: December 28, 2025</em>
      </p>

      <section>
        <h2>1. Acceptance of Terms</h2>
        <p>
          By accessing or using this website, our intake forms, consultation request pages, client
          portal (if applicable), or any related services (collectively, the “Services”), you agree
          to be bound by these Terms &amp; Conditions (“Terms”). If you do not agree, please discontinue
          use of the Services. These Terms apply to all visitors, prospective clients, clients,
          and any other users.
        </p>
      </section>

      <section>
        <h2>2. Informational Purposes Only — No Legal Advice</h2>
        <p>
          Content on this website is provided for general informational purposes only and may be
          considered attorney advertising. Nothing on this website is intended to be, nor should it
          be construed as, legal advice. You should not act or refrain from acting based on any
          information on this website without seeking appropriate legal or other professional advice
          on the particular facts and circumstances at issue.
        </p>
      </section>

      <section>
        <h2>3. No Attorney-Client Relationship</h2>
        <p>
          Visiting this website, contacting us through this website, completing a form, requesting a
          consultation, or sending email/text/social media messages does not create an attorney-client
          relationship. An attorney-client relationship is only formed after (a) we confirm that no
          conflict of interest exists and (b) you and our office sign a written agreement confirming
          representation.
        </p>
      </section>

      <section>
        <h2>4. Communications, Electronic Signatures &amp; SMS Consent</h2>
        <p>
          By submitting a form, requesting a consultation, or communicating with us electronically,
          you authorize us to contact you by phone, email, SMS text message, and other electronic
          means regarding intake, scheduling, your inquiry, and (where permitted) marketing updates.
          Message frequency may vary; message and data rates may apply. You can opt out of marketing
          SMS at any time by replying STOP. Opting out of certain communications may limit our
          ability to respond to your request.
        </p>
        <p>
          If you sign documents electronically, you agree that your electronic signature may be
          treated as the legal equivalent of your handwritten signature, to the extent permitted by
          applicable law.
        </p>
      </section>

      <section>
        <h2>5. Confidentiality of Submissions</h2>
        <p>
          Do not send confidential or time-sensitive information through this website or by email or
          SMS until an attorney-client relationship has been established. While we take reasonable
          measures to protect information submitted through our systems, internet communications may
          not be secure and could be intercepted, misdirected, or corrupted.
        </p>
      </section>

      <section>
        <h2>6. Eligibility, Jurisdiction &amp; Practice Area</h2>
        <p>
          This website is intended for individuals seeking information about personal injury matters.
          Our Services may not be available in all jurisdictions. We do not seek to represent anyone
          in any jurisdiction where this website would not comply with applicable laws and ethical
          rules.
        </p>
      </section>

      <section>
        <h2>7. Case Results, Testimonials &amp; No Guarantee</h2>
        <p>
          Any case results, settlements, verdicts, or testimonials described on this website are not
          a guarantee, warranty, or prediction of the outcome of your matter. Each case is different
          and depends on many factors, including facts, evidence, insurance coverage, applicable law,
          and the credibility of witnesses.
        </p>
      </section>

      <section>
        <h2>8. Fees, Costs &amp; No Guarantee of Recovery</h2>
        <p>
          Fee arrangements vary by matter and are only confirmed in a written agreement. If a matter
          is handled on a contingency fee basis, you may still be responsible for certain costs and
          expenses as explained in the written agreement. No attorney can ethically promise a
          specific outcome or guaranteed recovery.
        </p>
      </section>

      <section>
        <h2>9. Third-Party Links &amp; Platforms</h2>
        <p>
          This website may include links to third-party websites or services for your convenience.
          We do not control and are not responsible for third-party content, policies, or practices.
          Accessing third-party sites is at your own risk.
        </p>
      </section>

      <section>
        <h2>10. Intellectual Property</h2>
        <p>
          Unless otherwise stated, all content on this website (including text, graphics, logos,
          and media) is owned by or licensed to Edgar Lopez Law and is protected by applicable
          intellectual property laws. You may view and print pages for your personal use only.
          You may not reproduce, distribute, modify, or republish content without prior written
          permission.
        </p>
      </section>

      <section>
        <h2>11. Disclaimer of Warranties</h2>
        <p>
          This website and the Services are provided on an “as is” and “as available” basis. We make
          no warranties, express or implied, including warranties of merchantability, fitness for a
          particular purpose, non-infringement, or that the website will be uninterrupted, error-free,
          or secure.
        </p>
      </section>

      <section>
        <h2>12. Limitation of Liability</h2>
        <p>
          To the fullest extent permitted by law, Edgar Lopez Law and its owners, attorneys,
          employees, and agents shall not be liable for any indirect, incidental, special,
          consequential, or punitive damages arising out of or related to your use of the website or
          Services. To the extent liability is not otherwise excluded, our total liability for any
          claim shall not exceed $100.
        </p>
      </section>

      <section>
        <h2>13. Indemnification</h2>
        <p>
          You agree to defend, indemnify, and hold harmless Edgar Lopez Law and its attorneys,
          employees, and agents from and against any claims, liabilities, damages, losses, and
          expenses (including reasonable attorney fees) arising out of or related to: (a) your breach
          of these Terms; (b) your misuse of the website or Services; (c) your violation of any law;
          or (d) content you submit through our systems.
        </p>
      </section>

      <section>
        <h2>14. Privacy</h2>
        <p>
          Our collection and use of information is described in our&nbsp;
          <Link to="/privacy">Privacy Policy</Link>. By using the Services, you agree to our privacy
          practices.
        </p>
      </section>

      <section>
        <h2>15. Governing Law &amp; Venue</h2>
        <p>
          These Terms are governed by the laws of the State of California, without regard to
          conflict-of-law rules. Any dispute arising out of or related to these Terms or the Services
          shall be brought in a court of competent jurisdiction in California, in the county where
          our principal office is located, and you consent to personal jurisdiction there.
        </p>
      </section>

      <section>
        <h2>16. Changes to These Terms</h2>
        <p>
          We may revise these Terms from time to time. Updated versions will be posted on this page
          with a new effective date. Your continued use of the Services after changes become
          effective constitutes acceptance of the revised Terms.
        </p>
      </section>

      <section>
        <h2>17. Contact</h2>
        <p>
          For general inquiries, please use our&nbsp;
          <Link to="/contactus">Contact page</Link>.
        </p>
      </section>

      <section>
        <h2>18. Acceptance</h2>
        <p>
          By using this website, requesting a consultation, submitting information through our
          forms, or otherwise using the Services, you acknowledge that you have read, understood,
          and agree to these Terms.
        </p>
      </section>

      <p className="text-center" style={{ marginTop: 18, opacity: 0.85 }}>
        <em>
          Important: If you have a deadline (including a statute of limitations), contact an
          attorney immediately. Do not wait for a response through this website.
        </em>
      </p>
    </div>
  );
}

export default TermsAndConditions;